import {axiosWeb, axiosApi} from "@/js/axios";

const state = {
    contributors: [],
    contributor: {},
    perPage: 15,

    // Flags
    fetchingContributor: true,
    fetchingContributors: true,
};

const getters = {
    topContributors(state) {
        return _.orderBy(state.contributors, ['contributor', function (o) {
            return o.length;
        }], ["desc", "desc"]);
    }
};

const actions = {
    fetchContributors({state, commit, dispatch}) {
        commit('SET_FETCHING_CONTRIBUTORS', true);

        return new Promise((resolve, reject) => {
            axiosApi.get(`/api/v2/contributors`).then(({data}) => {
                if (data) {
                    let usersIds = [...new Set()];

                    for(let [key] of Object.entries(data.items)) {
                        usersIds.push(key);
                    }

                    axiosWeb.post(`/api/v1/contributors`, {
                        users: usersIds
                    }).then(response => {
                        if (response.data) {
                            for(let [key, value] of Object.entries(response.data)) {
                                data.items[key][0].name = value;
                            }

                            commit('SET_CONTRIBUTORS', data);
                            commit('SET_FETCHING_CONTRIBUTORS', false);
                            resolve(data)
                        }
                    }).catch(error => {
                        commit('SET_FETCHING_CONTRIBUTORS', false);
                    });
                }
            }).catch(error => {
                commit('SET_FETCHING_CONTRIBUTORS', false);
                reject(error);
            });
        });
    },
    fetchContributor({state, commit, dispatch}, payload) {
        commit('SET_FETCHING_CONTRIBUTOR', true);

        return new Promise((resolve, reject) => {
            axiosWeb.get(`/api/v1/user/${payload.contributorId}`).then(({data}) => {
                if (data) {
                    commit('SET_CONTRIBUTOR', data);
                    commit('SET_FETCHING_CONTRIBUTOR', false);
                    resolve(data)
                }
                commit('SET_FETCHING_CONTRIBUTOR', false);
            }).catch(error => {
                commit('SET_FETCHING_CONTRIBUTOR', false);
                reject(error);
            });
        });
    },
};

const mutations = {
    SET_CONTRIBUTORS(state, data) {
        state.contributors = data.items;
    },
    SET_FETCHING_CONTRIBUTORS(state, value) {
        state.fetchingContributors = value;
    },
    SET_CONTRIBUTOR(state, data) {
        state.contributor = data;
    },
    SET_FETCHING_CONTRIBUTOR(state, value) {
        state.fetchingContributor = value;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/contributor.js